"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es.object.define-property.js");

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/es.array.for-each.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

require("core-js/modules/es.object.define-properties.js");

require("core-js/modules/es.object.set-prototype-of.js");

require("core-js/modules/es.object.get-prototype-of.js");

require("core-js/modules/es.reflect.construct.js");

require("core-js/modules/es.object.create.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.symbol.iterator.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyleguidesApiFp = exports.StyleguidesApiAxiosParamCreator = exports.StyleguidesApi = void 0;

require("regenerator-runtime/runtime.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.replace.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/web.url.js");

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.promise.js");

var _axios = _interopRequireDefault(require("axios"));

var _common = require("../common");

var _base = require("../base");

var _models = require("../models");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/**
 * StyleguidesApi - axios parameter creator
 * @export
 */
var StyleguidesApiAxiosParamCreator = function StyleguidesApiAxiosParamCreator(configuration) {
  return {
    /**
     * Returns a single styleguide that user has access.  User is considered eligible to access a styleguide if any of the following conditions is met: * User is a member of the styleguide * User is a member of the organization that the styleguide belongs to * User is a member of a project which is linked to the styleguide (using `linked_project` parameter) * User is a member of a project and the styleguide is an ancestor of the project\'s linked styleguide (using `linked_project` parameter) * User is a member of a styleguide that the styleguide is one of its ancestors (using `linked_styleguide` parameter) 
     * @summary Get a single styleguide
     * @param {string} styleguideId Styleguide id
     * @param {string} [linkedProject] Reference project id
     * @param {string} [linkedStyleguide] Reference styleguide id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStyleguide: function () {
      var _getStyleguide = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(styleguideId, linkedProject, linkedStyleguide) {
        var options,
            localVarPath,
            localVarUrlObj,
            baseOptions,
            localVarRequestOptions,
            localVarHeaderParameter,
            localVarQueryParameter,
            headersFromBaseOptions,
            _args = arguments;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 3 && _args[3] !== undefined ? _args[3] : {};
                // verify required parameter 'styleguideId' is not null or undefined
                (0, _common.assertParamExists)('getStyleguide', 'styleguideId', styleguideId);
                localVarPath = "/v1/styleguides/{styleguide_id}".replace("{".concat("styleguide_id", "}"), encodeURIComponent(String(styleguideId))); // use dummy base URL string because the URL constructor only accepts absolute URLs.

                localVarUrlObj = new URL(localVarPath, _common.DUMMY_BASE_URL);

                if (configuration) {
                  baseOptions = configuration.baseOptions;
                }

                localVarRequestOptions = _objectSpread(_objectSpread({
                  method: 'GET'
                }, baseOptions), options);
                localVarHeaderParameter = {};
                localVarQueryParameter = {}; // authentication OAuth2 required
                // oauth required

                _context.next = 10;
                return (0, _common.setOAuthToObject)(localVarHeaderParameter, "OAuth2", [], configuration);

              case 10:
                _context.next = 12;
                return (0, _common.setBearerAuthToObject)(localVarHeaderParameter, configuration);

              case 12:
                if (linkedProject !== undefined) {
                  localVarQueryParameter['linked_project'] = linkedProject;
                }

                if (linkedStyleguide !== undefined) {
                  localVarQueryParameter['linked_styleguide'] = linkedStyleguide;
                }

                (0, _common.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                localVarRequestOptions.headers = _objectSpread(_objectSpread(_objectSpread({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                return _context.abrupt("return", {
                  url: (0, _common.toPathString)(localVarUrlObj),
                  options: localVarRequestOptions
                });

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function getStyleguide(_x, _x2, _x3) {
        return _getStyleguide.apply(this, arguments);
      }

      return getStyleguide;
    }(),

    /**
     * Fetch all design tokens of the styleguide
     * @summary Get styleguide design tokens
     * @param {string} styleguideId Styleguide id
     * @param {boolean} [includeLinkedStyleguides] Whether to include linked styleguides or not
     * @param {'kebab' | 'snake' | 'camel' | 'pascal' | 'constant' | 'original'} [tokenNameCase] Case for token names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStyleguideDesignTokens: function () {
      var _getStyleguideDesignTokens = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(styleguideId, includeLinkedStyleguides, tokenNameCase) {
        var options,
            localVarPath,
            localVarUrlObj,
            baseOptions,
            localVarRequestOptions,
            localVarHeaderParameter,
            localVarQueryParameter,
            headersFromBaseOptions,
            _args2 = arguments;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                options = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : {};
                // verify required parameter 'styleguideId' is not null or undefined
                (0, _common.assertParamExists)('getStyleguideDesignTokens', 'styleguideId', styleguideId);
                localVarPath = "/v1/styleguides/{styleguide_id}/design_tokens".replace("{".concat("styleguide_id", "}"), encodeURIComponent(String(styleguideId))); // use dummy base URL string because the URL constructor only accepts absolute URLs.

                localVarUrlObj = new URL(localVarPath, _common.DUMMY_BASE_URL);

                if (configuration) {
                  baseOptions = configuration.baseOptions;
                }

                localVarRequestOptions = _objectSpread(_objectSpread({
                  method: 'GET'
                }, baseOptions), options);
                localVarHeaderParameter = {};
                localVarQueryParameter = {}; // authentication OAuth2 required
                // oauth required

                _context2.next = 10;
                return (0, _common.setOAuthToObject)(localVarHeaderParameter, "OAuth2", [], configuration);

              case 10:
                _context2.next = 12;
                return (0, _common.setBearerAuthToObject)(localVarHeaderParameter, configuration);

              case 12:
                if (includeLinkedStyleguides !== undefined) {
                  localVarQueryParameter['include_linked_styleguides'] = includeLinkedStyleguides;
                }

                if (tokenNameCase !== undefined) {
                  localVarQueryParameter['token_name_case'] = tokenNameCase;
                }

                (0, _common.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                localVarRequestOptions.headers = _objectSpread(_objectSpread(_objectSpread({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                return _context2.abrupt("return", {
                  url: (0, _common.toPathString)(localVarUrlObj),
                  options: localVarRequestOptions
                });

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function getStyleguideDesignTokens(_x4, _x5, _x6) {
        return _getStyleguideDesignTokens.apply(this, arguments);
      }

      return getStyleguideDesignTokens;
    }(),

    /**
     * List all projects linked to the styleguide
     * @summary Get linked projects
     * @param {string} styleguideId Styleguide id
     * @param {number} [limit] Pagination limit
     * @param {number} [offset] Pagination offset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStyleguideLinkedProjects: function () {
      var _getStyleguideLinkedProjects = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(styleguideId, limit, offset) {
        var options,
            localVarPath,
            localVarUrlObj,
            baseOptions,
            localVarRequestOptions,
            localVarHeaderParameter,
            localVarQueryParameter,
            headersFromBaseOptions,
            _args3 = arguments;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                options = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                // verify required parameter 'styleguideId' is not null or undefined
                (0, _common.assertParamExists)('getStyleguideLinkedProjects', 'styleguideId', styleguideId);
                localVarPath = "/v1/styleguides/{styleguide_id}/linked_projects".replace("{".concat("styleguide_id", "}"), encodeURIComponent(String(styleguideId))); // use dummy base URL string because the URL constructor only accepts absolute URLs.

                localVarUrlObj = new URL(localVarPath, _common.DUMMY_BASE_URL);

                if (configuration) {
                  baseOptions = configuration.baseOptions;
                }

                localVarRequestOptions = _objectSpread(_objectSpread({
                  method: 'GET'
                }, baseOptions), options);
                localVarHeaderParameter = {};
                localVarQueryParameter = {}; // authentication OAuth2 required
                // oauth required

                _context3.next = 10;
                return (0, _common.setOAuthToObject)(localVarHeaderParameter, "OAuth2", [], configuration);

              case 10:
                _context3.next = 12;
                return (0, _common.setBearerAuthToObject)(localVarHeaderParameter, configuration);

              case 12:
                if (limit !== undefined) {
                  localVarQueryParameter['limit'] = limit;
                }

                if (offset !== undefined) {
                  localVarQueryParameter['offset'] = offset;
                }

                (0, _common.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                localVarRequestOptions.headers = _objectSpread(_objectSpread(_objectSpread({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                return _context3.abrupt("return", {
                  url: (0, _common.toPathString)(localVarUrlObj),
                  options: localVarRequestOptions
                });

              case 18:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function getStyleguideLinkedProjects(_x7, _x8, _x9) {
        return _getStyleguideLinkedProjects.apply(this, arguments);
      }

      return getStyleguideLinkedProjects;
    }(),

    /**
     * Returns members of a styleguide that user has access.  See [Styleguide docs](#getstyleguide) for more details about how `linked_project` and `linked_styleguide` parameters can be used to retrieve resources from styleguides that user is eligible to access. 
     * @summary Get styleguide members
     * @param {string} styleguideId Styleguide id
     * @param {number} [limit] Pagination limit
     * @param {number} [offset] Pagination offset
     * @param {string} [linkedProject] Reference project id
     * @param {string} [linkedStyleguide] Reference styleguide id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStyleguideMembers: function () {
      var _getStyleguideMembers = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(styleguideId, limit, offset, linkedProject, linkedStyleguide) {
        var options,
            localVarPath,
            localVarUrlObj,
            baseOptions,
            localVarRequestOptions,
            localVarHeaderParameter,
            localVarQueryParameter,
            headersFromBaseOptions,
            _args4 = arguments;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                options = _args4.length > 5 && _args4[5] !== undefined ? _args4[5] : {};
                // verify required parameter 'styleguideId' is not null or undefined
                (0, _common.assertParamExists)('getStyleguideMembers', 'styleguideId', styleguideId);
                localVarPath = "/v1/styleguides/{styleguide_id}/members".replace("{".concat("styleguide_id", "}"), encodeURIComponent(String(styleguideId))); // use dummy base URL string because the URL constructor only accepts absolute URLs.

                localVarUrlObj = new URL(localVarPath, _common.DUMMY_BASE_URL);

                if (configuration) {
                  baseOptions = configuration.baseOptions;
                }

                localVarRequestOptions = _objectSpread(_objectSpread({
                  method: 'GET'
                }, baseOptions), options);
                localVarHeaderParameter = {};
                localVarQueryParameter = {}; // authentication OAuth2 required
                // oauth required

                _context4.next = 10;
                return (0, _common.setOAuthToObject)(localVarHeaderParameter, "OAuth2", [], configuration);

              case 10:
                _context4.next = 12;
                return (0, _common.setBearerAuthToObject)(localVarHeaderParameter, configuration);

              case 12:
                if (limit !== undefined) {
                  localVarQueryParameter['limit'] = limit;
                }

                if (offset !== undefined) {
                  localVarQueryParameter['offset'] = offset;
                }

                if (linkedProject !== undefined) {
                  localVarQueryParameter['linked_project'] = linkedProject;
                }

                if (linkedStyleguide !== undefined) {
                  localVarQueryParameter['linked_styleguide'] = linkedStyleguide;
                }

                (0, _common.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                localVarRequestOptions.headers = _objectSpread(_objectSpread(_objectSpread({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                return _context4.abrupt("return", {
                  url: (0, _common.toPathString)(localVarUrlObj),
                  options: localVarRequestOptions
                });

              case 20:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function getStyleguideMembers(_x10, _x11, _x12, _x13, _x14) {
        return _getStyleguideMembers.apply(this, arguments);
      }

      return getStyleguideMembers;
    }(),

    /**
     * Lists all styleguides user is a member of unless `linked_project` or `linked_styleguide` parameter is given.  If `linked_project` parameter is provided, lists styleguide linked to the given project and its ancestors. Returns error if the project referenced with `linked_project` is not accessible.  Simiarly, lists styleguide linked to the given styleguide and its ancestors if `linked_styleguide` parameter is provided. Returns error if the styleguide referenced with `linked_styleguide` is not accessible.  ☝️ `linked_project` and `linked_styleguide` should not be used in conjunction.   Also, styleguides can be filtered by workspace using the `workspace` parameter. `workspace` parameter is ignored when `linked_project` or `linked_styleguide` parameter is provided. 
     * @summary Get all member styleguides
     * @param {number} [limit] Pagination limit
     * @param {number} [offset] Pagination offset
     * @param {string} [workspace] Workspace of the styleguide, it can be &#x60;personal&#x60; or the id of organization
     * @param {StyleguideStatusEnum} [status] Filter by status
     * @param {string} [linkedProject] Reference project id
     * @param {string} [linkedStyleguide] Reference styleguide id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStyleguides: function () {
      var _getStyleguides = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(limit, offset, workspace, status, linkedProject, linkedStyleguide) {
        var options,
            localVarPath,
            localVarUrlObj,
            baseOptions,
            localVarRequestOptions,
            localVarHeaderParameter,
            localVarQueryParameter,
            headersFromBaseOptions,
            _args5 = arguments;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                options = _args5.length > 6 && _args5[6] !== undefined ? _args5[6] : {};
                localVarPath = "/v1/styleguides"; // use dummy base URL string because the URL constructor only accepts absolute URLs.

                localVarUrlObj = new URL(localVarPath, _common.DUMMY_BASE_URL);

                if (configuration) {
                  baseOptions = configuration.baseOptions;
                }

                localVarRequestOptions = _objectSpread(_objectSpread({
                  method: 'GET'
                }, baseOptions), options);
                localVarHeaderParameter = {};
                localVarQueryParameter = {}; // authentication OAuth2 required
                // oauth required

                _context5.next = 9;
                return (0, _common.setOAuthToObject)(localVarHeaderParameter, "OAuth2", [], configuration);

              case 9:
                _context5.next = 11;
                return (0, _common.setBearerAuthToObject)(localVarHeaderParameter, configuration);

              case 11:
                if (limit !== undefined) {
                  localVarQueryParameter['limit'] = limit;
                }

                if (offset !== undefined) {
                  localVarQueryParameter['offset'] = offset;
                }

                if (workspace !== undefined) {
                  localVarQueryParameter['workspace'] = workspace;
                }

                if (status !== undefined) {
                  localVarQueryParameter['status'] = status;
                }

                if (linkedProject !== undefined) {
                  localVarQueryParameter['linked_project'] = linkedProject;
                }

                if (linkedStyleguide !== undefined) {
                  localVarQueryParameter['linked_styleguide'] = linkedStyleguide;
                }

                (0, _common.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                localVarRequestOptions.headers = _objectSpread(_objectSpread(_objectSpread({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                return _context5.abrupt("return", {
                  url: (0, _common.toPathString)(localVarUrlObj),
                  options: localVarRequestOptions
                });

              case 21:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function getStyleguides(_x15, _x16, _x17, _x18, _x19, _x20) {
        return _getStyleguides.apply(this, arguments);
      }

      return getStyleguides;
    }(),

    /**
     * Invite a member to the styleguide.
     * @summary Invite a member
     * @param {string} styleguideId Styleguide id
     * @param {StyleguideMemberInviteBody} styleguideMemberInviteBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inviteStyleguideMember: function () {
      var _inviteStyleguideMember = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(styleguideId, styleguideMemberInviteBody) {
        var options,
            localVarPath,
            localVarUrlObj,
            baseOptions,
            localVarRequestOptions,
            localVarHeaderParameter,
            localVarQueryParameter,
            headersFromBaseOptions,
            _args6 = arguments;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                options = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                // verify required parameter 'styleguideId' is not null or undefined
                (0, _common.assertParamExists)('inviteStyleguideMember', 'styleguideId', styleguideId); // verify required parameter 'styleguideMemberInviteBody' is not null or undefined

                (0, _common.assertParamExists)('inviteStyleguideMember', 'styleguideMemberInviteBody', styleguideMemberInviteBody);
                localVarPath = "/v1/styleguides/{styleguide_id}/members".replace("{".concat("styleguide_id", "}"), encodeURIComponent(String(styleguideId))); // use dummy base URL string because the URL constructor only accepts absolute URLs.

                localVarUrlObj = new URL(localVarPath, _common.DUMMY_BASE_URL);

                if (configuration) {
                  baseOptions = configuration.baseOptions;
                }

                localVarRequestOptions = _objectSpread(_objectSpread({
                  method: 'POST'
                }, baseOptions), options);
                localVarHeaderParameter = {};
                localVarQueryParameter = {}; // authentication OAuth2 required
                // oauth required

                _context6.next = 11;
                return (0, _common.setOAuthToObject)(localVarHeaderParameter, "OAuth2", [], configuration);

              case 11:
                _context6.next = 13;
                return (0, _common.setBearerAuthToObject)(localVarHeaderParameter, configuration);

              case 13:
                localVarHeaderParameter['Content-Type'] = 'application/json';
                (0, _common.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                localVarRequestOptions.headers = _objectSpread(_objectSpread(_objectSpread({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                localVarRequestOptions.data = (0, _common.serializeDataIfNeeded)((0, _models.transformStyleguideMemberInviteBodyToJSON)(styleguideMemberInviteBody), localVarRequestOptions, configuration);
                return _context6.abrupt("return", {
                  url: (0, _common.toPathString)(localVarUrlObj),
                  options: localVarRequestOptions
                });

              case 19:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function inviteStyleguideMember(_x21, _x22) {
        return _inviteStyleguideMember.apply(this, arguments);
      }

      return inviteStyleguideMember;
    }(),

    /**
     * Remove a member from the styleguide.
     * @summary Remove a member
     * @param {string} styleguideId Styleguide id
     * @param {string} memberId Member id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeStyleguideMember: function () {
      var _removeStyleguideMember = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(styleguideId, memberId) {
        var options,
            localVarPath,
            localVarUrlObj,
            baseOptions,
            localVarRequestOptions,
            localVarHeaderParameter,
            localVarQueryParameter,
            headersFromBaseOptions,
            _args7 = arguments;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                options = _args7.length > 2 && _args7[2] !== undefined ? _args7[2] : {};
                // verify required parameter 'styleguideId' is not null or undefined
                (0, _common.assertParamExists)('removeStyleguideMember', 'styleguideId', styleguideId); // verify required parameter 'memberId' is not null or undefined

                (0, _common.assertParamExists)('removeStyleguideMember', 'memberId', memberId);
                localVarPath = "/v1/styleguides/{styleguide_id}/members/{member_id}".replace("{".concat("styleguide_id", "}"), encodeURIComponent(String(styleguideId))).replace("{".concat("member_id", "}"), encodeURIComponent(String(memberId))); // use dummy base URL string because the URL constructor only accepts absolute URLs.

                localVarUrlObj = new URL(localVarPath, _common.DUMMY_BASE_URL);

                if (configuration) {
                  baseOptions = configuration.baseOptions;
                }

                localVarRequestOptions = _objectSpread(_objectSpread({
                  method: 'DELETE'
                }, baseOptions), options);
                localVarHeaderParameter = {};
                localVarQueryParameter = {}; // authentication OAuth2 required
                // oauth required

                _context7.next = 11;
                return (0, _common.setOAuthToObject)(localVarHeaderParameter, "OAuth2", [], configuration);

              case 11:
                _context7.next = 13;
                return (0, _common.setBearerAuthToObject)(localVarHeaderParameter, configuration);

              case 13:
                (0, _common.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                localVarRequestOptions.headers = _objectSpread(_objectSpread(_objectSpread({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                return _context7.abrupt("return", {
                  url: (0, _common.toPathString)(localVarUrlObj),
                  options: localVarRequestOptions
                });

              case 17:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function removeStyleguideMember(_x23, _x24) {
        return _removeStyleguideMember.apply(this, arguments);
      }

      return removeStyleguideMember;
    }(),

    /**
     * Update a styleguide\'s name and description
     * @summary Update a styleguide
     * @param {string} styleguideId Styleguide id
     * @param {StyleguideUpdateBody} styleguideUpdateBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateStyleguide: function () {
      var _updateStyleguide = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(styleguideId, styleguideUpdateBody) {
        var options,
            localVarPath,
            localVarUrlObj,
            baseOptions,
            localVarRequestOptions,
            localVarHeaderParameter,
            localVarQueryParameter,
            headersFromBaseOptions,
            _args8 = arguments;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                options = _args8.length > 2 && _args8[2] !== undefined ? _args8[2] : {};
                // verify required parameter 'styleguideId' is not null or undefined
                (0, _common.assertParamExists)('updateStyleguide', 'styleguideId', styleguideId); // verify required parameter 'styleguideUpdateBody' is not null or undefined

                (0, _common.assertParamExists)('updateStyleguide', 'styleguideUpdateBody', styleguideUpdateBody);
                localVarPath = "/v1/styleguides/{styleguide_id}".replace("{".concat("styleguide_id", "}"), encodeURIComponent(String(styleguideId))); // use dummy base URL string because the URL constructor only accepts absolute URLs.

                localVarUrlObj = new URL(localVarPath, _common.DUMMY_BASE_URL);

                if (configuration) {
                  baseOptions = configuration.baseOptions;
                }

                localVarRequestOptions = _objectSpread(_objectSpread({
                  method: 'PATCH'
                }, baseOptions), options);
                localVarHeaderParameter = {};
                localVarQueryParameter = {}; // authentication OAuth2 required
                // oauth required

                _context8.next = 11;
                return (0, _common.setOAuthToObject)(localVarHeaderParameter, "OAuth2", [], configuration);

              case 11:
                _context8.next = 13;
                return (0, _common.setBearerAuthToObject)(localVarHeaderParameter, configuration);

              case 13:
                localVarHeaderParameter['Content-Type'] = 'application/json';
                (0, _common.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                localVarRequestOptions.headers = _objectSpread(_objectSpread(_objectSpread({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                localVarRequestOptions.data = (0, _common.serializeDataIfNeeded)((0, _models.transformStyleguideUpdateBodyToJSON)(styleguideUpdateBody), localVarRequestOptions, configuration);
                return _context8.abrupt("return", {
                  url: (0, _common.toPathString)(localVarUrlObj),
                  options: localVarRequestOptions
                });

              case 19:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      function updateStyleguide(_x25, _x26) {
        return _updateStyleguide.apply(this, arguments);
      }

      return updateStyleguide;
    }()
  };
};
/**
 * StyleguidesApi - functional programming interface
 * @export
 */


exports.StyleguidesApiAxiosParamCreator = StyleguidesApiAxiosParamCreator;

var StyleguidesApiFp = function StyleguidesApiFp(configuration) {
  var localVarAxiosParamCreator = StyleguidesApiAxiosParamCreator(configuration);
  return {
    /**
     * Returns a single styleguide that user has access.  User is considered eligible to access a styleguide if any of the following conditions is met: * User is a member of the styleguide * User is a member of the organization that the styleguide belongs to * User is a member of a project which is linked to the styleguide (using `linked_project` parameter) * User is a member of a project and the styleguide is an ancestor of the project\'s linked styleguide (using `linked_project` parameter) * User is a member of a styleguide that the styleguide is one of its ancestors (using `linked_styleguide` parameter) 
     * @summary Get a single styleguide
     * @param {string} styleguideId Styleguide id
     * @param {string} [linkedProject] Reference project id
     * @param {string} [linkedStyleguide] Reference styleguide id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStyleguide: function getStyleguide(styleguideId, linkedProject, linkedStyleguide, options) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var localVarAxiosArgs;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return localVarAxiosParamCreator.getStyleguide(styleguideId, linkedProject, linkedStyleguide, options);

              case 2:
                localVarAxiosArgs = _context9.sent;
                return _context9.abrupt("return", (0, _common.createRequestFunction)(localVarAxiosArgs, _axios["default"], _base.BASE_PATH, configuration));

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }))();
    },

    /**
     * Fetch all design tokens of the styleguide
     * @summary Get styleguide design tokens
     * @param {string} styleguideId Styleguide id
     * @param {boolean} [includeLinkedStyleguides] Whether to include linked styleguides or not
     * @param {'kebab' | 'snake' | 'camel' | 'pascal' | 'constant' | 'original'} [tokenNameCase] Case for token names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStyleguideDesignTokens: function getStyleguideDesignTokens(styleguideId, includeLinkedStyleguides, tokenNameCase, options) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var localVarAxiosArgs;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return localVarAxiosParamCreator.getStyleguideDesignTokens(styleguideId, includeLinkedStyleguides, tokenNameCase, options);

              case 2:
                localVarAxiosArgs = _context10.sent;
                return _context10.abrupt("return", (0, _common.createRequestFunction)(localVarAxiosArgs, _axios["default"], _base.BASE_PATH, configuration));

              case 4:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }))();
    },

    /**
     * List all projects linked to the styleguide
     * @summary Get linked projects
     * @param {string} styleguideId Styleguide id
     * @param {number} [limit] Pagination limit
     * @param {number} [offset] Pagination offset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStyleguideLinkedProjects: function getStyleguideLinkedProjects(styleguideId, limit, offset, options) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var localVarAxiosArgs;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return localVarAxiosParamCreator.getStyleguideLinkedProjects(styleguideId, limit, offset, options);

              case 2:
                localVarAxiosArgs = _context11.sent;
                return _context11.abrupt("return", (0, _common.createRequestFunction)(localVarAxiosArgs, _axios["default"], _base.BASE_PATH, configuration));

              case 4:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }))();
    },

    /**
     * Returns members of a styleguide that user has access.  See [Styleguide docs](#getstyleguide) for more details about how `linked_project` and `linked_styleguide` parameters can be used to retrieve resources from styleguides that user is eligible to access. 
     * @summary Get styleguide members
     * @param {string} styleguideId Styleguide id
     * @param {number} [limit] Pagination limit
     * @param {number} [offset] Pagination offset
     * @param {string} [linkedProject] Reference project id
     * @param {string} [linkedStyleguide] Reference styleguide id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStyleguideMembers: function getStyleguideMembers(styleguideId, limit, offset, linkedProject, linkedStyleguide, options) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        var localVarAxiosArgs;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return localVarAxiosParamCreator.getStyleguideMembers(styleguideId, limit, offset, linkedProject, linkedStyleguide, options);

              case 2:
                localVarAxiosArgs = _context12.sent;
                return _context12.abrupt("return", (0, _common.createRequestFunction)(localVarAxiosArgs, _axios["default"], _base.BASE_PATH, configuration));

              case 4:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }))();
    },

    /**
     * Lists all styleguides user is a member of unless `linked_project` or `linked_styleguide` parameter is given.  If `linked_project` parameter is provided, lists styleguide linked to the given project and its ancestors. Returns error if the project referenced with `linked_project` is not accessible.  Simiarly, lists styleguide linked to the given styleguide and its ancestors if `linked_styleguide` parameter is provided. Returns error if the styleguide referenced with `linked_styleguide` is not accessible.  ☝️ `linked_project` and `linked_styleguide` should not be used in conjunction.   Also, styleguides can be filtered by workspace using the `workspace` parameter. `workspace` parameter is ignored when `linked_project` or `linked_styleguide` parameter is provided. 
     * @summary Get all member styleguides
     * @param {number} [limit] Pagination limit
     * @param {number} [offset] Pagination offset
     * @param {string} [workspace] Workspace of the styleguide, it can be &#x60;personal&#x60; or the id of organization
     * @param {StyleguideStatusEnum} [status] Filter by status
     * @param {string} [linkedProject] Reference project id
     * @param {string} [linkedStyleguide] Reference styleguide id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStyleguides: function getStyleguides(limit, offset, workspace, status, linkedProject, linkedStyleguide, options) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        var localVarAxiosArgs;
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return localVarAxiosParamCreator.getStyleguides(limit, offset, workspace, status, linkedProject, linkedStyleguide, options);

              case 2:
                localVarAxiosArgs = _context13.sent;
                return _context13.abrupt("return", (0, _common.createRequestFunction)(localVarAxiosArgs, _axios["default"], _base.BASE_PATH, configuration));

              case 4:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      }))();
    },

    /**
     * Invite a member to the styleguide.
     * @summary Invite a member
     * @param {string} styleguideId Styleguide id
     * @param {StyleguideMemberInviteBody} styleguideMemberInviteBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inviteStyleguideMember: function inviteStyleguideMember(styleguideId, styleguideMemberInviteBody, options) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
        var localVarAxiosArgs;
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return localVarAxiosParamCreator.inviteStyleguideMember(styleguideId, styleguideMemberInviteBody, options);

              case 2:
                localVarAxiosArgs = _context14.sent;
                return _context14.abrupt("return", (0, _common.createRequestFunction)(localVarAxiosArgs, _axios["default"], _base.BASE_PATH, configuration));

              case 4:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14);
      }))();
    },

    /**
     * Remove a member from the styleguide.
     * @summary Remove a member
     * @param {string} styleguideId Styleguide id
     * @param {string} memberId Member id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeStyleguideMember: function removeStyleguideMember(styleguideId, memberId, options) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
        var localVarAxiosArgs;
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return localVarAxiosParamCreator.removeStyleguideMember(styleguideId, memberId, options);

              case 2:
                localVarAxiosArgs = _context15.sent;
                return _context15.abrupt("return", (0, _common.createRequestFunction)(localVarAxiosArgs, _axios["default"], _base.BASE_PATH, configuration));

              case 4:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15);
      }))();
    },

    /**
     * Update a styleguide\'s name and description
     * @summary Update a styleguide
     * @param {string} styleguideId Styleguide id
     * @param {StyleguideUpdateBody} styleguideUpdateBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateStyleguide: function updateStyleguide(styleguideId, styleguideUpdateBody, options) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
        var localVarAxiosArgs;
        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.next = 2;
                return localVarAxiosParamCreator.updateStyleguide(styleguideId, styleguideUpdateBody, options);

              case 2:
                localVarAxiosArgs = _context16.sent;
                return _context16.abrupt("return", (0, _common.createRequestFunction)(localVarAxiosArgs, _axios["default"], _base.BASE_PATH, configuration));

              case 4:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16);
      }))();
    }
  };
};
/**
 * Search parameters for getStyleguide operation in StyleguidesApi.
 * @export
 * @interface StyleguidesApiGetStyleguideSearchParams
 */


exports.StyleguidesApiFp = StyleguidesApiFp;

/**
 * StyleguidesApi - object-oriented interface
 * @export
 * @class StyleguidesApi
 * @extends {BaseAPI}
 */
var StyleguidesApi = /*#__PURE__*/function (_BaseAPI) {
  _inherits(StyleguidesApi, _BaseAPI);

  var _super = _createSuper(StyleguidesApi);

  function StyleguidesApi() {
    _classCallCheck(this, StyleguidesApi);

    return _super.apply(this, arguments);
  }

  _createClass(StyleguidesApi, [{
    key: "getStyleguide",
    value:
    /**
     * Returns a single styleguide that user has access.  User is considered eligible to access a styleguide if any of the following conditions is met: * User is a member of the styleguide * User is a member of the organization that the styleguide belongs to * User is a member of a project which is linked to the styleguide (using `linked_project` parameter) * User is a member of a project and the styleguide is an ancestor of the project\'s linked styleguide (using `linked_project` parameter) * User is a member of a styleguide that the styleguide is one of its ancestors (using `linked_styleguide` parameter) 
     * @summary Get a single styleguide
     * @param {string} styleguideId Styleguide id
     * @param {StyleguidesApiGetStyleguideSearchParams} [searchParams] Search parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StyleguidesApi
     */
    function () {
      var _getStyleguide2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17(styleguideId) {
        var searchParams,
            options,
            styleguidesApiFp,
            request,
            response,
            _args17 = arguments;
        return regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                searchParams = _args17.length > 1 && _args17[1] !== undefined ? _args17[1] : {};
                options = _args17.length > 2 ? _args17[2] : undefined;
                styleguidesApiFp = StyleguidesApiFp(this.configuration);
                _context17.next = 5;
                return styleguidesApiFp.getStyleguide(styleguideId, searchParams.linkedProject, searchParams.linkedStyleguide, options);

              case 5:
                request = _context17.sent;
                _context17.next = 8;
                return request(this.axios, this.basePath);

              case 8:
                response = _context17.sent;
                return _context17.abrupt("return", _objectSpread(_objectSpread({}, response), {}, {
                  data: (0, _models.transformJSONToStyleguide)(response.data)
                }));

              case 10:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function getStyleguide(_x27) {
        return _getStyleguide2.apply(this, arguments);
      }

      return getStyleguide;
    }()
    /**
     * Fetch all design tokens of the styleguide
     * @summary Get styleguide design tokens
     * @param {string} styleguideId Styleguide id
     * @param {StyleguidesApiGetStyleguideDesignTokensSearchParams} [searchParams] Search parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StyleguidesApi
     */

  }, {
    key: "getStyleguideDesignTokens",
    value: function () {
      var _getStyleguideDesignTokens2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18(styleguideId) {
        var searchParams,
            options,
            styleguidesApiFp,
            request,
            response,
            _args18 = arguments;
        return regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                searchParams = _args18.length > 1 && _args18[1] !== undefined ? _args18[1] : {};
                options = _args18.length > 2 ? _args18[2] : undefined;
                styleguidesApiFp = StyleguidesApiFp(this.configuration);
                _context18.next = 5;
                return styleguidesApiFp.getStyleguideDesignTokens(styleguideId, searchParams.includeLinkedStyleguides, searchParams.tokenNameCase, options);

              case 5:
                request = _context18.sent;
                _context18.next = 8;
                return request(this.axios, this.basePath);

              case 8:
                response = _context18.sent;
                return _context18.abrupt("return", _objectSpread(_objectSpread({}, response), {}, {
                  data: (0, _models.transformJSONToDesignTokens)(response.data)
                }));

              case 10:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function getStyleguideDesignTokens(_x28) {
        return _getStyleguideDesignTokens2.apply(this, arguments);
      }

      return getStyleguideDesignTokens;
    }()
    /**
     * List all projects linked to the styleguide
     * @summary Get linked projects
     * @param {string} styleguideId Styleguide id
     * @param {StyleguidesApiGetStyleguideLinkedProjectsSearchParams} [searchParams] Search parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StyleguidesApi
     */

  }, {
    key: "getStyleguideLinkedProjects",
    value: function () {
      var _getStyleguideLinkedProjects2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19(styleguideId) {
        var searchParams,
            options,
            styleguidesApiFp,
            request,
            response,
            _args19 = arguments;
        return regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                searchParams = _args19.length > 1 && _args19[1] !== undefined ? _args19[1] : {};
                options = _args19.length > 2 ? _args19[2] : undefined;
                styleguidesApiFp = StyleguidesApiFp(this.configuration);
                _context19.next = 5;
                return styleguidesApiFp.getStyleguideLinkedProjects(styleguideId, searchParams.limit, searchParams.offset, options);

              case 5:
                request = _context19.sent;
                _context19.next = 8;
                return request(this.axios, this.basePath);

              case 8:
                response = _context19.sent;
                return _context19.abrupt("return", _objectSpread(_objectSpread({}, response), {}, {
                  data: response.data.map(_models.transformJSONToProject)
                }));

              case 10:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function getStyleguideLinkedProjects(_x29) {
        return _getStyleguideLinkedProjects2.apply(this, arguments);
      }

      return getStyleguideLinkedProjects;
    }()
    /**
     * Returns members of a styleguide that user has access.  See [Styleguide docs](#getstyleguide) for more details about how `linked_project` and `linked_styleguide` parameters can be used to retrieve resources from styleguides that user is eligible to access. 
     * @summary Get styleguide members
     * @param {string} styleguideId Styleguide id
     * @param {StyleguidesApiGetStyleguideMembersSearchParams} [searchParams] Search parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StyleguidesApi
     */

  }, {
    key: "getStyleguideMembers",
    value: function () {
      var _getStyleguideMembers2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20(styleguideId) {
        var searchParams,
            options,
            styleguidesApiFp,
            request,
            response,
            _args20 = arguments;
        return regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                searchParams = _args20.length > 1 && _args20[1] !== undefined ? _args20[1] : {};
                options = _args20.length > 2 ? _args20[2] : undefined;
                styleguidesApiFp = StyleguidesApiFp(this.configuration);
                _context20.next = 5;
                return styleguidesApiFp.getStyleguideMembers(styleguideId, searchParams.limit, searchParams.offset, searchParams.linkedProject, searchParams.linkedStyleguide, options);

              case 5:
                request = _context20.sent;
                _context20.next = 8;
                return request(this.axios, this.basePath);

              case 8:
                response = _context20.sent;
                return _context20.abrupt("return", _objectSpread(_objectSpread({}, response), {}, {
                  data: response.data.map(_models.transformJSONToStyleguideMember)
                }));

              case 10:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function getStyleguideMembers(_x30) {
        return _getStyleguideMembers2.apply(this, arguments);
      }

      return getStyleguideMembers;
    }()
    /**
     * Lists all styleguides user is a member of unless `linked_project` or `linked_styleguide` parameter is given.  If `linked_project` parameter is provided, lists styleguide linked to the given project and its ancestors. Returns error if the project referenced with `linked_project` is not accessible.  Simiarly, lists styleguide linked to the given styleguide and its ancestors if `linked_styleguide` parameter is provided. Returns error if the styleguide referenced with `linked_styleguide` is not accessible.  ☝️ `linked_project` and `linked_styleguide` should not be used in conjunction.   Also, styleguides can be filtered by workspace using the `workspace` parameter. `workspace` parameter is ignored when `linked_project` or `linked_styleguide` parameter is provided. 
     * @summary Get all member styleguides
     * @param {StyleguidesApiGetStyleguidesSearchParams} [searchParams] Search parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StyleguidesApi
     */

  }, {
    key: "getStyleguides",
    value: function () {
      var _getStyleguides2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21() {
        var searchParams,
            options,
            styleguidesApiFp,
            request,
            response,
            _args21 = arguments;
        return regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                searchParams = _args21.length > 0 && _args21[0] !== undefined ? _args21[0] : {};
                options = _args21.length > 1 ? _args21[1] : undefined;
                styleguidesApiFp = StyleguidesApiFp(this.configuration);
                _context21.next = 5;
                return styleguidesApiFp.getStyleguides(searchParams.limit, searchParams.offset, searchParams.workspace, searchParams.status, searchParams.linkedProject, searchParams.linkedStyleguide, options);

              case 5:
                request = _context21.sent;
                _context21.next = 8;
                return request(this.axios, this.basePath);

              case 8:
                response = _context21.sent;
                return _context21.abrupt("return", _objectSpread(_objectSpread({}, response), {}, {
                  data: response.data.map(_models.transformJSONToStyleguide)
                }));

              case 10:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));

      function getStyleguides() {
        return _getStyleguides2.apply(this, arguments);
      }

      return getStyleguides;
    }()
    /**
     * Invite a member to the styleguide.
     * @summary Invite a member
     * @param {string} styleguideId Styleguide id
     * @param {StyleguideMemberInviteBody} styleguideMemberInviteBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StyleguidesApi
     */

  }, {
    key: "inviteStyleguideMember",
    value: function () {
      var _inviteStyleguideMember2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22(styleguideId, styleguideMemberInviteBody, options) {
        var styleguidesApiFp, request, response;
        return regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                styleguidesApiFp = StyleguidesApiFp(this.configuration);
                _context22.next = 3;
                return styleguidesApiFp.inviteStyleguideMember(styleguideId, styleguideMemberInviteBody, options);

              case 3:
                request = _context22.sent;
                _context22.next = 6;
                return request(this.axios, this.basePath);

              case 6:
                response = _context22.sent;
                return _context22.abrupt("return", response);

              case 8:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));

      function inviteStyleguideMember(_x31, _x32, _x33) {
        return _inviteStyleguideMember2.apply(this, arguments);
      }

      return inviteStyleguideMember;
    }()
    /**
     * Remove a member from the styleguide.
     * @summary Remove a member
     * @param {string} styleguideId Styleguide id
     * @param {string} memberId Member id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StyleguidesApi
     */

  }, {
    key: "removeStyleguideMember",
    value: function () {
      var _removeStyleguideMember2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee23(styleguideId, memberId, options) {
        var styleguidesApiFp, request, response;
        return regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                styleguidesApiFp = StyleguidesApiFp(this.configuration);
                _context23.next = 3;
                return styleguidesApiFp.removeStyleguideMember(styleguideId, memberId, options);

              case 3:
                request = _context23.sent;
                _context23.next = 6;
                return request(this.axios, this.basePath);

              case 6:
                response = _context23.sent;
                return _context23.abrupt("return", response);

              case 8:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));

      function removeStyleguideMember(_x34, _x35, _x36) {
        return _removeStyleguideMember2.apply(this, arguments);
      }

      return removeStyleguideMember;
    }()
    /**
     * Update a styleguide\'s name and description
     * @summary Update a styleguide
     * @param {string} styleguideId Styleguide id
     * @param {StyleguideUpdateBody} styleguideUpdateBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StyleguidesApi
     */

  }, {
    key: "updateStyleguide",
    value: function () {
      var _updateStyleguide2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee24(styleguideId, styleguideUpdateBody, options) {
        var styleguidesApiFp, request, response;
        return regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                styleguidesApiFp = StyleguidesApiFp(this.configuration);
                _context24.next = 3;
                return styleguidesApiFp.updateStyleguide(styleguideId, styleguideUpdateBody, options);

              case 3:
                request = _context24.sent;
                _context24.next = 6;
                return request(this.axios, this.basePath);

              case 6:
                response = _context24.sent;
                return _context24.abrupt("return", response);

              case 8:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, this);
      }));

      function updateStyleguide(_x37, _x38, _x39) {
        return _updateStyleguide2.apply(this, arguments);
      }

      return updateStyleguide;
    }()
  }]);

  return StyleguidesApi;
}(_base.BaseAPI);

exports.StyleguidesApi = StyleguidesApi;